import { metadata as orbitalFrame } from '../../pages/projects/orbital-frame'

export default [
  orbitalFrame
]
